import { render, staticRenderFns } from "./SimpleButtonCta.vue?vue&type=template&id=2a4bf9d2&"
import script from "./SimpleButtonCta.vue?vue&type=script&lang=js&"
export * from "./SimpleButtonCta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4bf9d2')) {
      api.createRecord('2a4bf9d2', component.options)
    } else {
      api.reload('2a4bf9d2', component.options)
    }
    module.hot.accept("./SimpleButtonCta.vue?vue&type=template&id=2a4bf9d2&", function () {
      api.rerender('2a4bf9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/broadband/components/SimpleButtonCta.vue"
export default component.exports